import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MultiSelectMatrix from './../../MultiSelectMatrix';

const HelpParagraph = styled.p`
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 0;
    padding: 0 0 1.66rem 1.66rem;
    text-align: left;
    user-select: none;
`;

const ResourceImportWorkflowStepThree = ({
    loading,
    onChange,
    resources,
    selections,
    setRenderStep,
    submitExtRefSelections,
    resourceName,
    resourceNameShort,
    ...props
}) => {
    return (
        <div className="modal-content">
            <div className="modal-header">
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 className="modal-title">
                    <span id="ext-links-references-add-page-title">
                        Import Existing {resourceName}s
                    </span>
                </h4>
            </div>
            <div
                className="modal-body align-center"
                style={{ padding: '1.66rem 0 0 0' }}
            >
                <MultiSelectMatrix
                    datum={resources}
                    selections={selections}
                    onChange={onChange}
                    itemNomenclature={`reference`}
                    itemNomenclaturePlural={`references`}
                >
                    <HelpParagraph>
                        <strong>
                            {selections.length.toLocaleString()}&nbsp;of&nbsp;
                            {Object.keys(
                                resources.available
                            ).length.toLocaleString()}{' '}
                            available {resourceNameShort.toLowerCase()}s selected for import:
                        </strong>
                    </HelpParagraph>
                </MultiSelectMatrix>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => setRenderStep(2)}
                >
                    Back
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    data-dismiss="modal"
                    onClick={() => submitExtRefSelections()}
                    disabled={!selections.length || loading}
                >
                    {loading ? `Importing...` : `Import`}
                </button>
            </div>
        </div>
    );
};

ResourceImportWorkflowStepThree.propTypes = {
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    resources: PropTypes.object,
    selections: PropTypes.array,
    setRenderStep: PropTypes.func,
    submitExtRefSelections: PropTypes.func
};

ResourceImportWorkflowStepThree.defaultProps = {
    loading: false,
    onChange: () => null,
    resources: {},
    selections: [],
    setRenderStep: () => null,
    submitExtRefSelections: () => null
};

export default ResourceImportWorkflowStepThree;
